<template>
  <v-row>
    <v-col cols="12" lg="10" offset-lg="1">
      <v-breadcrumbs divider=">" :items="breadcrumbs" class="pb-3 pl-1" />
      <v-card class="mb-1">
        <v-card-title class="theme">
          <v-icon class="white--text">volume_up</v-icon>
          <span class="headline ml-2 white--text">Edit announcement</span>
          <v-spacer />
          <v-btn depressed @click="dialog = true" class="error rounded-sm"
            >delete</v-btn
          >
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-form ref="form" v-model="formValidation">
            <v-container>
              <v-row>
                <v-col cols="12" lg="5">
                  <v-text-field
                    label="Title*"
                    :rules="[validationRules.required]"
                    persistent-hint
                    hint="Title of the announcement"
                    v-model="announcement.title"
                  />
                  <v-autocomplete
                    label="Visibility"
                    persistent-hint
                    hint="Draft or should be Published"
                    :items="visibility"
                    item-text="name"
                    item-value="value"
                    v-model="announcement.visibility"
                  />
                  <v-autocomplete
                    label="Type"
                    persistent-hint
                    hint="General or Emergency"
                    :items="type"
                    item-text="name"
                    item-value="value"
                    v-model="announcement.type"
                  />
                  <v-dialog
                    ref="dialog"
                    v-model="modal"
                    :return-value.sync="announcement.expires_at"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        persistent-hint
                        label="Announcement expiration date*"
                        :rules="[validationRules.required]"
                        v-model="computedDateFormatted"
                        hint="dd-mm-yyyy format"
                        readonly
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="announcement.expires_at"
                      scrollable
                      :first-day-of-week="1"
                    >
                      <v-btn text class="theme-text" @click="modal = false"
                        >Cancel</v-btn
                      >
                      <v-spacer />
                      <v-btn
                        text
                        class="theme-text"
                        @click="$refs.dialog.save(announcement.expires_at)"
                        >OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col cols="12" lg="7">
                  <div class="mt-3">
                    <ckeditor
                      :editor="editor"
                      :config="editorConfig"
                      v-model="announcement.description"
                      style="min-height: 300px !important"
                    />
                  </div>
                </v-col>
              </v-row>
              <v-btn depressed class="save white--text ml-0 mt-3" @click="save"
                >Save</v-btn
              >
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline pt-4">
          <v-spacer />
          <span>Are you sure?</span>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text class="my-3 text-xs-center"
          >You will not be able to undo this operation.</v-card-text
        >
        <v-divider />
        <v-card-actions>
          <v-btn color="success" text @click="dialog = !dialog">cancel</v-btn>
          <v-spacer />
          <v-btn color="error" text @click="deleteAnnouncement">delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import BalloonEditor from "@ckeditor/ckeditor5-editor-balloon/src/ballooneditor";
import {mapGetters} from "vuex";

import {Actions} from "@/views/actions";
import {Breadcrumbs} from "@/views/breadcrumbs";
import {Component} from "@/views/component";
import {Constants} from "@/views/constants";

export default {
  name: Component.Protected.Announcement.Edit,
  data: () => ({
    editor: BalloonEditor,
    editorData: "<p>Content of the editor.</p>",
    breadcrumbs: Breadcrumbs.Announcement.Edit,
    announcement: {
      type: "",
      title: "",
      expires_at: "",
      description: "",
      visibility: "",
    },
    id: "",
    modal: false,
    dialog: false,
    type: Constants.Announcement.Types.Obj,
    visibility: Constants.Announcement.Visibility.Obj,
    formValidation: true,
    editorConfig: {},
  }),
  computed: {
    ...mapGetters(["userInfo"]),
    computedDateFormatted() {
      return this.datePickerFormat(this.announcement.expires_at);
    },
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        const data = {
          title: this.announcement.title,
          description: this.announcement.description,
          visibility: this.announcement.visibility,
          type: this.announcement.type,
          expires_at: this.computedDateFormatted,
        };

        let payload = { id: this.id, data: data };
        this.$store
          .dispatch(Actions.Announcement.Edit, payload)
          .then(() => {
            this.$router.push({ name: Component.Protected.Announcement.List });
          })
          .catch((e) => {
            console.error(Constants.Announcement.Messages.Error.Edit, e);
            this.snackbar = true;
            this.snackbarMessage = Constants.Announcement.Messages.Error.Edit;
          });
      }
    },
    deleteAnnouncement() {
      if (!this.validRole() || !this.id) return false;
      this.$store
        .dispatch(Actions.Announcement.Delete, this.id)
        .catch((err) => {
          this.snackbar = true;
          this.snackbarMessage = Constants.Announcement.Messages.Error.Delete;
          console.error(Constants.Announcement.Messages.Error.Delete, err);
        })
        .finally(() =>
          this.$router.push({ name: Component.Protected.Announcement.List })
        );
    },
    getAnnouncement() {
      this.$store
        .dispatch(Actions.Announcement.Get, this.id)
        .then((r) => {
          if (r.status === 200) {
            this.announcement = {
              ...r.data,
              created_at: this.formatFromDate(r.data.created_at),
              expires_at: r.data.expires_at
                ? r.data.expires_at.substring(0, 10)
                : "",
            };
          }
        })
        .catch((e) => {
          console.error(Constants.Announcement.Messages.Error.Get, e);
          this.snackbar = true;
          this.snackbarMessage = Constants.Announcement.Messages.Error.Get;
        });
    },
    validRole(){
      return this.userInfo.role === Constants.Roles.Manager ||
          this.userInfo.role === Constants.Roles.HR
    }
  },
  created() {
    if (!this.$route.params.id || this.userInfo.role === Constants.Roles.Employee) {
      this.$router.go(-1);
      return false;
    }
    this.id = this.$route.params.id;
    if (this.userInfo) {
      this.getAnnouncement();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.getAnnouncement());
    }
    this.editorConfig = this.editorConfigAnnouncement;
  },
};
</script>
<style scoped>
* >>> div.v-picker__title {
  background-color: #551738 !important;
  border-color: #551738 !important;
}

/* * >>> div.v-date-picker-table {
  height: 200px !important;
} */
.ck.ck-editor__editable > .ck-placeholder::before {
  color: lightgray !important;
}
.ck.ck-editor__editable_inline > :first-child {
  font-family: Roboto Slab;
}
.ck-content {
  color: #272929;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.ck-focused {
  border: thin solid lightgray !important;
  outline: none !important;
  box-shadow: none !important;
}
.ck-content:h1{
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
    .ck-content:h1 {
        font-size: 20px;
    }
    .ck-content:h2{
      font-size: 18px
    }
}
@media (min-width: 769px) and (max-width: 1024px) {
    .ck-content:h1 {
        font-size: 22px;
    }
    .ck-content:h2{
      font-size: 20px;
    }
}
</style>